import { reducerWithInitialState } from 'typescript-fsa-reducers';
import {
    openDialogAction,
    closeDialogAction,
} from '@app/react/middleware/dialog/action';

export type DialogState = {
    show: boolean;
    okHandler: () => void;
    cancelHandler: () => void;
    userData: any;
};

export interface IDialogReducer {
    states: { [key in string]: DialogState };
}

const initState: IDialogReducer = {
    states: {},
};

export const dialogReducer = reducerWithInitialState(initState)
    .case(
        openDialogAction,
        (state, {
            key, okHandler, cancelHandler, userData,
        }) => ({
            ...state,
            states: {
                ...state.states,
                [key]: {
                    show: true,
                    okHandler,
                    cancelHandler,
                    userData,
                },
            },
        }),
    )
    .case(closeDialogAction, (state, { key }) => {
        delete state.states[key];
        return {
            ...state,
        };
    });
